// extracted by mini-css-extract-plugin
export default {"header":"Login-Page_header__Jrtde","page__container":"Login-Page_page__container__ST0QJ","form__wrapper":"Login-Page_form__wrapper__S0-ih","greyLogo":"Login-Page_greyLogo__wUWnP"};